export const NOTIFICATION_SOUND_URL = "/sounds/new-message-sound.mp3";